import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import PDFViewer from "../../../../data/viewEPUB";

const MyModal = ({ open, handleClose, pdfUrl }) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "80%",
          height: "80%",
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "8px",
          overflow: "hidden",
        }}
      >
        <PDFViewer pdfUrl={pdfUrl} />
      </div>
    </Modal>
  );
};

// const App = () => {
//   const [isModalOpen, setModalOpen] = useState(false);
//   const epubUrl = "http://localhost:5000/upload/epub/Dir-SMDform13/childrens-literature.epub";

//   const handleOpen = () => setModalOpen(true);
//   const handleClose = () => setModalOpen(false);

//   return (
//     <div>
//       <button onClick={handleOpen}>Open EPUB Viewer</button>
//       <MyModal open={isModalOpen} handleClose={handleClose} epubUrl={epubUrl} />
//     </div>
//   );
// };

export default MyModal;
